import { Component, OnInit } from '@angular/core';
import { ContainerJobUpsertFormComponent } from './container-job-upsert-form/container-job-upsert-form.component';

@Component({
  selector: 'app-container-job-upsert',
  standalone: true,
  imports: [ContainerJobUpsertFormComponent],
  templateUrl: './container-job-upsert.component.html',
  styleUrl: './container-job-upsert.component.scss'
})
export class ContainerJobUpsertComponent implements OnInit {

  ngOnInit(): void {

  }
}
